import { ArrowRight, MonitorDown } from "lucide-react";
import type { Locale } from "./i18n";
import { localizedPath } from "./route";

// Small, static hint shown under the download area of every platform downloader.
// Only claims what SiloSave Desktop does: batch downloads and saving posts that
// need the user's own login. No analytics event on purpose.
const copy: Record<Locale, string> = {
  en: "Need batch downloads or login-only posts? Try SiloSave Desktop free for 7 days",
  "zh-tw": "要一次抓很多、抓登入才看得到的貼文？試用 SiloSave 電腦版，免費 7 天",
  "zh-cn": "要一次下载很多、或下载登录后才能看到的帖子？试用 SiloSave 电脑版，免费 7 天",
  ja: "まとめて保存したい、ログインが必要な投稿も保存したいなら、SiloSave Desktop を7日間無料でお試し",
  ko: "한 번에 많이 받거나 로그인해야 보이는 게시물이 필요하세요? SiloSave Desktop 7일 무료 체험",
  es: "¿Descargas por lotes o publicaciones que requieren iniciar sesión? Prueba SiloSave Desktop gratis 7 días",
  "pt-br": "Precisa baixar em lote ou posts que exigem login? Teste o SiloSave Desktop grátis por 7 dias",
  fr: "Besoin de téléchargements par lot ou de publications visibles une fois connecté ? Essayez SiloSave Desktop gratuitement 7 jours",
  de: "Batch-Downloads oder Beiträge, die eine Anmeldung erfordern? SiloSave Desktop 7 Tage kostenlos testen",
  id: "Perlu unduh massal atau posting yang butuh login? Coba SiloSave Desktop gratis 7 hari",
  vi: "Cần tải hàng loạt hoặc bài viết phải đăng nhập mới xem được? Dùng thử SiloSave Desktop miễn phí 7 ngày",
  th: "ต้องการดาวน์โหลดทีละหลายรายการหรือโพสต์ที่ต้องล็อกอิน? ลองใช้ SiloSave Desktop ฟรี 7 วัน",
};

export function getDesktopPromoStripText(locale: Locale): string {
  return copy[locale] || copy.en;
}

export function DesktopPromoStrip({ locale }: { locale: Locale }) {
  return <a className="desktop-promo-strip" href={localizedPath(locale, "desktop")}>
    <MonitorDown size={17} aria-hidden="true" />
    <span>{getDesktopPromoStripText(locale)}</span>
    <ArrowRight size={16} aria-hidden="true" />
  </a>;
}
